module.exports = __webpack_public_path__ + "static/media/logo144.7f59ab31.png";